import { InstanceStateTypes } from '.';
import type { IInstance, IInstanceData } from '.';
import { Module } from '../';

export class Instance implements IInstance {
  id?: string | undefined;
  learningObjectId?: string | undefined;
  name = '';
  dateCreated = '';
  isDefault = true;
  isFlexible = false;
  completionDeadline = '';
  enrollmentDeadline = '';
  state: InstanceStateTypes = InstanceStateTypes.Active;
  modules: Module[] = [];
  subInstances: Instance[] = [];

  constructor(data: IInstanceData) {
    Object.assign(this, data);

    if (data?.modules) {
      this.modules = data.modules.map((m) => new Module(m));
    }
    if (data?.subInstances) {
      this.subInstances = data.subInstances.map((m) => new Instance(m));
    }
  }

  get isDeadlinePassed(): boolean {
    if (this.completionDeadline && new Date().getTime() - new Date(this.completionDeadline).getTime() > 0) {
      return true;
    }
    if (this.enrollmentDeadline && new Date().getTime() - new Date(this.enrollmentDeadline).getTime() > 0) {
      return true;
    }
    return false;
  }

  get isActive(): boolean {
    return this.state == InstanceStateTypes.Active && !this.isDeadlinePassed;
  }

  validate(): void {
    throw new Error('Method not implemented.');
  }
}
